import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
// import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
// import { TypeOptions } from '@app/interface/type-options';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { LayoutService } from '@app/layout/layout.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { RouterModule } from '@angular/router';
// import { ChangeDetectionStrategy, signal } from '@angular/core';
// import { EventEmitter, OnChanges, OnInit, Output } from '@angular/core';
import { isNullOrUndefined } from '@app/shared/utils';
import { MatExpansionModule } from '@angular/material/expansion';
import { AsyncPipe } from '@angular/common';
// import { InvitationComponent } from '@app/invitation/invitation.component';
import { InvitationApiService } from '@app/services/invitation-api.service';
import { InvitationInterface } from '@app/interface/invitation';
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// import { RecursiveInterface } from '@app/services/base-authenticated.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CopyToClipboardComponent } from '@app/copy-to-clipboard/copy-to-clipboard.component';
import { SubscriptionApiService } from '@app/services/subscription-api.service';
import { SubscriptionInterface } from '@app/interface/subscription';
import { ChangeDetectorRef } from '@angular/core';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { Organizations } from '@app/interface/organizations';
import { OrganizationApi } from '@app/services/organization-api.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  DeleteAccountDialogComponent,
  HelpCenterDialogComponent,
  ManageSubscriptionDialogComponent,
} from '@app/manage-subscription-dialog/manage-subscription-dialog.component';
import { ChangeProfilePicDialogComponent } from '@app/change-profile-pic-dialog/change-profile-pic-dialog.component';
import { VersionEasterEggDialogComponent } from '@app/version-easter-egg-dialog/version-easter-egg-dialog.component';
import { DatePipe } from '@angular/common';
import { WriteAtInfoAtIzysrlComponent } from '@app/write-at-info-at-izysrl/write-at-info-at-izysrl.component';
import { PensionFundOptions } from '@app/interface/invoice';
import { ViewPaymentDialogComponent } from '@app/view-payment-dialog/view-payment-dialog.component';
import { PaymentInterface } from '@app/interface/payment';
import { PaymentApiService } from '@app/services/payment-api.service';
import { RecursiveInterface } from '@app/services/base-authenticated.service';
import { ExtraPaidServicesApiService } from '@app/services/extrapaidservices-api.service';
import {
  ExtrapaidserviceInterface,
  TypeCode,
} from '@app/interface/extrapaidservice';
import { ReferralRequestTableComponent } from '@app/referral-request-table/referral-request-table.component';
import { AtecoCodeApiService } from '@app/services/ateco-code-api.service';
import { AtecoCodeInterface } from '@app/interface/ateco-code';
import { APP_VERSION, APP_DEVELOPER } from '@app/app-info';

@Component({
  selector: 'izy-profile',
  imports: [
    MatCardModule,
    CommonModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatTabsModule,
    MatIconModule,
    RouterModule,
    AsyncPipe,
    // InvitationComponent,
    MatListModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    BackHeaderComponent,
    MatSlideToggleModule,
    DatePipe,
    // ReferralRequestTableComponent,
  ],
  standalone: true,
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent {
  pensionFundOptions: PensionFundOptions[] = [
    {
      code: 'TC01',
      name: 'Cassa nazionale previdenza e assistenza avvocati e procuratori legali',
    },
    { code: 'TC02', name: 'Cassa previdenza dottori commercialisti' },
    { code: 'TC03', name: 'Cassa previdenza e assistenza geometri' },
    {
      code: 'TC04',
      name: 'Cassa nazionale previdenza e assistenza ingegneri e architetti liberi professionisti',
    },
    { code: 'TC05', name: 'Cassa nazionale del notariato' },
    {
      code: 'TC06',
      name: 'Cassa nazionale previdenza e assistenza ragionieri e periti commerciali',
    },
    {
      code: 'TC07',
      name: 'Ente nazionale assistenza agenti e rappresentanti di commercio (ENASARCO)',
    },
    {
      code: 'TC08',
      name: 'Ente nazionale previdenza e assistenza consulenti del lavoro (ENPACL)',
    },
    {
      code: 'TC09',
      name: 'Ente nazionale previdenza e assistenza medici (ENPAM)',
    },
    {
      code: 'TC10',
      name: 'Ente nazionale previdenza e assistenza farmacisti (ENPAF)',
    },
    {
      code: 'TC11',
      name: 'Ente nazionale previdenza e assistenza veterinari (ENPAV)',
    },
    {
      code: 'TC12',
      name: "Ente nazionale previdenza e assistenza impiegati dell'agricoltura (ENPAIA)",
    },
    {
      code: 'TC13',
      name: 'Fondo previdenza impiegati imprese di spedizione e agenzie marittime',
    },
    {
      code: 'TC14',
      name: 'Istituto nazionale previdenza giornalisti italiani (INPGI)',
    },
    {
      code: 'TC15',
      name: 'Opera nazionale assistenza orfani sanitari italiani (ONAOSI)',
    },
    {
      code: 'TC16',
      name: 'Cassa autonoma assistenza integrativa giornalisti italiani (CASAGIT)',
    },
    {
      code: 'TC17',
      name: 'Ente previdenza periti industriali e periti industriali laureati (EPPI)',
    },
    {
      code: 'TC18',
      name: 'Ente previdenza e assistenza pluricategoriale (EPAP)',
    },
    {
      code: 'TC19',
      name: 'Ente nazionale previdenza e assistenza biologi (ENPAB)',
    },
    {
      code: 'TC20',
      name: 'Ente nazionale previdenza e assistenza professione infermieristica (ENPAPI)',
    },
    {
      code: 'TC21',
      name: 'Ente nazionale previdenza e assistenza psicologi (ENPAP)',
    },
    { code: 'TC22', name: 'INPS' },
  ];

  readonly appVersion = APP_VERSION;
  readonly developerName = APP_DEVELOPER;

  invitationForm: FormGroup;
  showInvitationForm = false;
  organizationForm: FormGroup;
  isUpdatingOrganization = false;

  // profile picture properties
  profilePicUrl: string | null = null;
  isUploadingProfilePic = false;

  constructor(
    public auth: AngularFireAuth,
    private route: ActivatedRoute,
    public layoutService: LayoutService, // private router: Router  FIXME: is public right??
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private invitationService: InvitationApiService,
    private extraPaidServicesService: ExtraPaidServicesApiService,
    private subscriptionService: SubscriptionApiService,
    private AtecoCodesApi: AtecoCodeApiService,
    private paymentService: PaymentApiService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    public organizationService: OrganizationApi,
  ) {
    this.invitationForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });

    // Initialize organization form with your actual fields
    this.organizationForm = this.fb.group({
      // email_address: ['', [Validators.email]],
      // pec: ['', [Validators.email]],
      // address: [''],
      type: ['STARTUP'],
      qualification_title: [''],
      qualification_title_abbreviation: [''],
      qualification_subtitle: [''],
      is_healthcare: [false],
      has_revenue_stamp_for_company: [false],
      favorite_pension_fund: [''],
      // Add other fields as needed
    });
  }

  organization_data: Organizations | null = null;

  atecoCodes: AtecoCodeInterface[] = [];

  invitations: InvitationInterface[] = [];
  extraPaidServices: ExtrapaidserviceInterface[] = [];
  subscription: SubscriptionInterface | undefined;
  isLoading = false;
  organizationId?: number;
  isSendingInvitation = false;

  paymentObject: PaymentInterface | undefined;

  ngOnInit() {
    this.getorganizationId();
    this.getOrganizationData();
    this.loadInvitations();
    this.loadExtraPaidServices();
    this.loadSubscription();
    this.loadAtecoCodes();

    this.cdr.detectChanges();
  }

  getorganizationId() {
    // console.log('Getting company ID');
    this.route.paramMap.subscribe((params) => {
      // console.log('Getting company ID');
      let organizationId = params.get('organizationId') || undefined;
      // console.log('Company ID:', organizationId);
      if (organizationId !== undefined) {
        this.organizationId = +organizationId;
        // this.getProjects();
        this.getCompany();
      } else {
        setTimeout(() => {
          this.getorganizationId();
        }, 1000);
      }
    });
  }

  private getOrganizationData() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;

    const filterParams = {
      organization_id: organization_id,
    };

    this.organizationService
      .getOrganization<Organizations>(organization_id, filterParams)
      .subscribe({
        next: (organization_data: Organizations) => {
          // console.log('Organization:', organization_data);
          this.organization_data = organization_data;

          // Set profile picture URL
          if (organization_data.profile_pic) {
            this.profilePicUrl = organization_data.profile_pic;
          }

          // Populate the form with existing data
          this.populateOrganizationForm(organization_data);

          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error loading organization:', err);
          this.showErrorMessage('Failed to load organization');
          this.cdr.detectChanges();
        },
      });
  }

  private loadAtecoCodes() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    // this.errorMessage = null;

    this.AtecoCodesApi.getAllAtecoCodes<AtecoCodeInterface>(
      organization_id,
      {},
    ).subscribe({
      next: (response: RecursiveInterface<AtecoCodeInterface>) => {
        if (response.completed) {
          // Store all ATECO codes in the component property
          this.atecoCodes = response.results;

          // console.log('All ateco codes loaded', this.atecoCodes.length);
        } else {
          // Optional: Show loading progress
          // console.log(
          //   `Loaded ${response.results.length} saved ateco codes so far...`,
          // );
          this.atecoCodes = response.results;
        }
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error loading ateco codes:', err);
        this.showErrorMessage('Errore nel caricamento dei codici ATECO.');
      },
    });
  }

  // Populate form with organization data
  private populateOrganizationForm(organization: Organizations) {
    this.organizationForm.patchValue({
      type: organization.type || 'STARTUP',
      favorite_pension_fund: organization.favorite_pension_fund || 'TC22',
      qualification_title: organization.qualification_title || '',
      qualification_title_abbreviation:
        organization.qualification_title_abbreviation || '',
      qualification_subtitle: organization.qualification_subtitle || '',
      is_healthcare: organization.is_healthcare || false,
      has_revenue_stamp_for_company:
        organization.has_revenue_stamp_for_company || false,
    });
  }

  // Update organization settings
  updateOrganizationSettings() {
    if (this.organizationForm.invalid || !this.organizationId) {
      this.showErrorMessage('Controlla i campi obbligatori');
      return;
    }

    this.isUpdatingOrganization = true;

    const updateData = {
      ...this.organizationForm.value,
    };

    this.organizationService
      .updateOrganizationDetails(
        this.organizationId,
        this.organizationId,
        updateData,
      )
      .subscribe({
        next: (updatedOrganization: Organizations) => {
          this.organization_data = updatedOrganization;
          this.isUpdatingOrganization = false;
          this.organizationForm.markAsPristine();
          this.showSuccessMessage('Impostazioni aggiornate con successo!');
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          console.error('Error updating organization:', error);
          this.isUpdatingOrganization = false;
          this.showErrorMessage(
            "Errore durante l'aggiornamento: " +
              (error.error?.message || 'Unknown error'),
          );
        },
      });
  }

  // Reset form to original values
  resetOrganizationForm() {
    if (this.organization_data) {
      this.populateOrganizationForm(this.organization_data);
      this.organizationForm.markAsPristine();
    }
  }

  // Check if form has changes
  hasFormChanges(): boolean {
    return this.organizationForm.dirty;
  }

  getCompany(): void {
    if (!isNullOrUndefined(this.organizationId) && this.organizationId !== 0) {
      // this.companyService.getCompanyDetail(this.organizationId, {}).subscribe({
      //   next: (res) => {
      //     this.company = res;
      //   },
      //   error: (error) => {
      //     console.error(error);
      //   },
      // });
    } else {
      console.warn('Company ID is undefined or null or 0');
      // setTimeout(() => {
      //   this.getCompany();
      //   this.getProjects();
      // }, 1000);
    }
  }

  // invitations
  loadInvitations() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;

    const subscription = this.invitationService
      .getOrganizationInvitations(organization_id, {})
      .subscribe({
        next: (response: any) => {
          // console.log('RAW API RESPONSE:', response);

          // Check what the actual structure is
          if (Array.isArray(response)) {
            this.invitations = response;
          } else if (response && Array.isArray(response)) {
            this.invitations = response;
          } else if (response && response.data) {
            this.invitations = response.data;
          } else {
            console.warn('Unexpected response structure:', response);
            this.invitations = [];
          }

          this.isLoading = false;
          // console.log('Processed invitations:', this.invitations);
        },
        error: (error: any) => {
          console.error('Error loading invitations:', error);
          this.isLoading = false;
        },
      });
  }

  loadSubscription() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;

    this.subscriptionService
      .getAllSubscriptions<SubscriptionInterface>(organization_id, {})
      .subscribe({
        next: (response: any) => {
          console.log('subscription:', response);

          this.subscription = response.results[0]; // assigning the API response

          // console.log(this.subscription);

          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          console.error('Error loading subscription:', error); // Fixed error message
          this.isLoading = false;
          this.cdr.detectChanges();
        },
      });
  }

  // Extra Paid Services
  loadExtraPaidServices() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;

    const extraPaidServices = this.extraPaidServicesService
      .getExtrapaidservicesList(organization_id, {})
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;

          this.extraPaidServices = response.results;
          // console.log('this.extraPaidServices', this.extraPaidServices);

          // console.log('Processed invitations:', this.invitations);
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          console.error('Error loading invitations:', error);
          this.isLoading = false;
          this.cdr.detectChanges();
        },
      });
  }

  // Get status color for chips
  // getStatusColor(status: string): string {
  //   switch (status) {
  //     case 'PENDING':
  //       return 'primary';
  //     case 'ACCEPTED':
  //       return 'accent';
  //     case 'DECLINED':
  //       return 'warn';
  //     case 'EXPIRED':
  //       return 'warn';
  //     default:
  //       return 'primary';
  //   }
  // }

  getBooleanDisplay(value: boolean | null | undefined): string {
    if (value === null || value === undefined) return 'Non specificato';
    return value ? 'Sì' : 'No';
  }

  getActiveValueDisplay(value: string | null | undefined): string {
    if (value === null || value === undefined) return 'Non specificato';

    const statusMap: Record<string, string> = {
      ACTIVE: 'ATTIVO',
      EXPIRED: 'SCADUTO',
      CANCELED: 'CANCELLATO',
      PENDING: 'IN ATTESA',
      EXPIRING: 'IN SCADENZA',
    };

    return statusMap[value] || 'Non specificato';
  }

  getPlanTypeDisplay(value: string | null | undefined): string {
    if (value === null || value === undefined) return 'Non specificato';

    const statusMap: Record<string, string> = {
      ANNUAL: 'Annuale',
      MONTHLY: 'Mensile',
    };

    return statusMap[value] || 'Non specificato';
  }

  getExtraServiceTypeDisplay(value: string | null | undefined): string {
    if (value === null || value === undefined) return 'Non specificato';

    // console.log(value);

    const typeMap: Record<TypeCode, string> = {
      ANNUAL: 'Annuale',
      PERIODIC: 'Periodico',
      TANTUM: 'Una tantum',
    };

    return typeMap[value as TypeCode] || 'Non specificato';
  }

  getInvitationTypeDisplay(value: string | null | undefined): string {
    if (value === null || value === undefined) return 'Non specificato';

    const statusMap: Record<string, string> = {
      PENDING: 'In attesa',
      ACCEPTED: 'Accettato',
      EXPIRED: 'Scaduto',
      DECLINED: 'Rifiutato',
    };

    return statusMap[value] || 'Non specificato';
  }

  // Format date if available
  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  }

  // Send invitation
  sendInvitation() {
    if (this.invitationForm.invalid || !this.organizationId) {
      return;
    }

    this.cdr.detectChanges();

    this.isSendingInvitation = true;
    const email = this.invitationForm.get('email')?.value;

    this.invitationService
      .sendInvitation(this.organizationId, email)
      .subscribe({
        next: (response) => {
          console.log('Invitation sent:', response);
          this.isSendingInvitation = false;
          this.showSuccessMessage('Invito creato con successo!');
          this.invitationForm.reset();
          this.showInvitationForm = false;
          this.loadInvitations(); // Refresh the list

          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error sending invitation:', error);
          this.isSendingInvitation = false;
          this.showErrorMessage(
            'Errore nella creazione: ' +
              (error.error?.message || 'Unknown error'),
          );

          this.cdr.detectChanges();
        },
      });
  }

  openSubscriptionDialog(): void {
    if (!this.subscription || !this.organizationId) {
      this.showErrorMessage('Impossibile gestire abbonamento: dati mancanti');
      return;
    }

    const dialogRef = this.dialog.open(ManageSubscriptionDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: 'auto',
      minHeight: '350px',
      data: {
        subscription: this.subscription,
        organizationId: this.organizationId,
        organization: this.organization_data,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.updateSubscriptionAutoRenew(result.auto_renew);
      }
    });
  }

  openPaymentDialog(): void {
    if (!this.subscription || !this.organizationId) {
      this.showErrorMessage('Impossibile gestire pagamento: dati mancanti');
      return;
    }

    const payment_id = this.subscription.payment_id;

    const filterParams = {
      id: payment_id,
    };

    this.paymentService
      .getAllPayments<PaymentInterface>(this.organizationId, filterParams)
      .subscribe({
        next: (response: RecursiveInterface<PaymentInterface>) => {
          // Extract the payment from the response
          const payment_data = response.results?.[0] || response;

          // Move dialog opening here, after data is loaded
          const dialogRef = this.dialog.open(ViewPaymentDialogComponent, {
            width: '90vw',
            maxWidth: '550px',
            height: 'auto',
            minHeight: '400px',
            data: {
              payment: payment_data, // Use the fetched data directly
              organizationId: this.organizationId,
              organization: this.organization_data,
            },
          });

          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error('Error loading payment:', err);
          this.showErrorMessage('Errore durante il caricamento del pagamento');
          this.cdr.detectChanges();
        },
      });
  }

  openHelpCenterDialog(): void {
    if (!this.subscription || !this.organizationId) {
      this.showErrorMessage('Impossibile gestire abbonamento: dati mancanti');
      return;
    }

    const dialogRef = this.dialog.open(HelpCenterDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: 'auto',
      minHeight: '250px',
      data: {
        subscription: this.subscription,
        organizationId: this.organizationId,
        organization: this.organization_data,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.updateSubscriptionAutoRenew(result.auto_renew);
      }
    });
  }

  openDeleteAccountDialog(): void {
    if (!this.subscription || !this.organizationId) {
      this.showErrorMessage('Impossibile gestire abbonamento: dati mancanti');
      return;
    }

    const dialogRef = this.dialog.open(DeleteAccountDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: 'auto',
      minHeight: '260px',
      data: {
        subscription: this.subscription,
        organizationId: this.organizationId,
        organization: this.organization_data,
      },
    });
  }

  // Add new method to update auto_renew
  private updateSubscriptionAutoRenew(autoRenew: boolean): void {
    if (!this.subscription || !this.organizationId) {
      return;
    }

    // Workaround if subscription doesn't have id property
    // Try different possible id properties that might exist
    const subscriptionId =
      (this.subscription as any).id ||
      (this.subscription as any).subscription_id ||
      this.findSubscriptionId();

    if (!subscriptionId) {
      this.showErrorMessage('Impossibile trovare ID abbonamento');
      return;
    }

    this.isLoading = true;

    this.subscriptionService
      .updateSubscriptionDetails(this.organizationId, subscriptionId, {
        auto_renew: autoRenew,
      })
      .subscribe({
        next: (updatedSubscription: SubscriptionInterface) => {
          // Update local subscription data
          this.subscription = updatedSubscription;
          this.isLoading = false;
          this.showSuccessMessage(
            'Impostazioni abbonamento aggiornate con successo!',
          );
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          console.error('Error updating subscription:', error);
          this.isLoading = false;
          this.showErrorMessage(
            "Errore durante l'aggiornamento: " +
              (error.error?.message || 'Unknown error'),
          );
          this.cdr.detectChanges();
        },
      });
  }

  // Helper method to find subscription ID
  private findSubscriptionId(): number | null {
    if (!this.subscription) return null;

    // Check various possible ID properties
    const possibleIdProps = [
      'id',
      'subscription_id',
      'subscriptionId',
      'subscriptionID',
    ];

    for (const prop of possibleIdProps) {
      if ((this.subscription as any)[prop]) {
        return (this.subscription as any)[prop];
      }
    }

    return null;
  }

  openVersionEasterEggDialog(): void {
    this.dialog.open(VersionEasterEggDialogComponent, {
      width: '90vw',
      maxWidth: '350px',
      height: 'auto',
      minHeight: '230px',
    });
  }

  openChangeProfilePicDialog(): void {
    const dialogRef = this.dialog.open(ChangeProfilePicDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: 'auto', // Changed to auto for better content fit
      minHeight: '270px',
    });

    dialogRef.afterClosed().subscribe((selectedFile: File | null) => {
      if (selectedFile) {
        this.uploadProfilePicture(selectedFile);
      }
    });
  }

  private uploadProfilePicture(file: File): void {
    if (!this.organizationId) {
      this.showErrorMessage('Organization ID not found');
      return;
    }

    this.isUploadingProfilePic = true;

    // Create FormData for file upload
    const formData = new FormData();
    formData.append('profile_pic', file);

    this.organizationService
      .updateOrganizationWithFile(this.organizationId, formData)
      .subscribe({
        next: (updatedOrganization: Organizations) => {
          this.organization_data = updatedOrganization;
          this.profilePicUrl = updatedOrganization.profile_pic;
          this.isUploadingProfilePic = false;
          this.showSuccessMessage('Foto profilo aggiornata!');
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          console.error('Error uploading profile picture:', error);
          this.isUploadingProfilePic = false;
          this.showErrorMessage(
            'Errore: ' + (error.error?.message || 'Errore sconosciuto'),
          );
        },
      });
  }

  // Toggle invitation form
  toggleInvitationForm() {
    this.showInvitationForm = !this.showInvitationForm;
    if (!this.showInvitationForm) {
      this.invitationForm.reset();
    }
  }

  // Refresh invitations
  refreshInvitations() {
    this.loadInvitations();
  }

  generateInvitationLink(uuid: string): string {
    const baseUrl = window.location.origin; // Gets http://localhost:4200 or your domain
    return `${baseUrl}/accept-invitation/${uuid}`;
  }

  async copyInvitationLink(uuid: string) {
    const invitationLink = this.generateInvitationLink(uuid);

    const dialogRef = this.dialog.open(CopyToClipboardComponent, {
      width: '90vw',
      maxWidth: '600px', // Slightly wider to accommodate the link
      height: '250px',
      data: { invitationLink }, // Pass the link to the dialog
    });

    const result = await dialogRef.afterClosed().toPromise();

    if (result) {
      // User successfully copied the link
      this.showSuccessMessage('Link di invito copiato negli appunti.');
    }
  }

  async openWriteAtIzySrlDialog() {
    const dialogRef = this.dialog.open(WriteAtInfoAtIzysrlComponent, {
      width: '90vw',
      maxWidth: '450px', // Slightly wider to accommodate the link
      height: '350px',
      data: {
        organization: this.organization_data,
      },
    });

    // const result = await dialogRef.afterClosed().toPromise();

    // if (result) {
    //   // User successfully copied the link
    //   this.showSuccessMessage('Indirizzo mail copiato negli appunti.');
    // }
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
